import { render, staticRenderFns } from "./privacyPolocy.vue?vue&type=template&id=28ce257b&scoped=true"
import script from "./privacyPolocy.vue?vue&type=script&lang=js"
export * from "./privacyPolocy.vue?vue&type=script&lang=js"
import style1 from "./privacyPolocy.vue?vue&type=style&index=1&id=28ce257b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ce257b",
  null
  
)

export default component.exports